<template>
    <form-template @submit="proceed">
        <div class="col-span-4 md:col-span-1">
            <p class="text-smoke-dark text-sm">Select Provider</p>
        </div>
        <div class="col-span-4 md:col-span-3">
            <div class="grid grid-cols-4 gap-3 w-full">
                <template v-if="cables.length">
                    <div class="col-span-2 md:col-span-1" v-for="cable in cables" :key="cable.billername">
                        <biller-radio
                            @select="(val) => selectCable(val)"
                            :value="cable.billername"
                            :active="data.tv_category === cable.billername.toLowerCase()"
                        >
                            <img :src="require(`@/assets/img/${cable.billername.toLowerCase()}.png`)" class="mx-auto" />
                        </biller-radio>
                    </div>
                </template>
                <template v-else>
                    <div class="col-span-2 md:col-span-1" v-for="index in 3" :key="index">
                        <div
                            class="flex items-center justify-center border rounded-lg px-4 py-8 h-16 bg-transparent border-snow-200 w-full"
                        >
                            <div class="skeleton"></div>
                        </div>
                    </div>
                </template>
                <!-- <div class="col-span-2 md:col-span-1">
                    <biller-radio @select="selectCable('others')" value="others" :active="selectedCable === 'others'">
                        <div class="flex flex-col items-center w-full">
                            <p class="text-grey-300 text-sm">Others</p>
                            <div class="flex items-center justify-center">
                                <div class="h-1 w-1 rounded-full bg-smoke-200 "></div>
                                <div class="h-1 w-1 rounded-full bg-smoke-200 mx-1"></div>
                                <div class="h-1 w-1 rounded-full bg-smoke-200 "></div>
                            </div>
                        </div>
                    </biller-radio>
                </div> -->
            </div>
        </div>
        <div class="col-span-4 md:col-span-1">
            <p class="text-smoke-dark text-sm">SmartCard / IUC Number</p>
        </div>
        <div class="col-span-4 md:col-span-3">
            <biller-input
                placeholder="Input Smart Card Number"
                required
                type="number"
                v-model="smart_card_number"
                :disabled="!data.tv_category"
                @click="checkTv"
            >
                <template v-slot:append>
                    <template v-if="loadCableUser">
                        <img src="@/assets/svg/load.svg" alt="loader" class="w-6" />
                    </template>
                    <template v-else-if="cableUserSuccess">
                        <img src="@/assets/svg/check.svg" alt="loader" class="w-6" />
                    </template>
                </template>
            </biller-input>
        </div>
        <div class="col-span-4 md:col-span-1">
            <p class="text-smoke-dark text-sm" id="bouquet">Bouquet</p>
        </div>
        <div class="col-span-4 md:col-span-3">
            <biller-dropdown
                :items="products"
                label_id="bouquet"
                :option="option"
                :loading="loadCableUser"
                @click="checkUser"
                @select="selectPlan"
            />
        </div>
    </form-template>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { debounce } from '@/util/debounce'
import { verifyCableUser } from '@/api/bills'
export default {
    metaInfo: {
        title: 'Cable Subscription',
    },
    data() {
        return {
            smart_card_number: '',
            loadCableUser: false,
            cableUserSuccess: false,
            items: [],
            option: 'Select Bouquet',
            data: {
                account_number: '',
                account_name: '',
                bundle: '',
                amount: '',
                tv_category: '',
            },
        }
    },
    computed: {
        ...mapGetters('Bill', {
            cables: 'GET_CABLE_CATEGORIES',
            products: 'GET_CABLE_PRODUCTS',
        }),
    },
    updated() {
        if (this.products.length) {
            // this.items = this.products.filter((val) => val.bundleCode !== '')
        }
    },
    created() {
        this.debouncedVerifyUserData = debounce(this.verifyUserData, 1000)
    },
    watch: {
        smart_card_number: function(newValue) {
            if (newValue.length > 9) {
                this.debouncedVerifyUserData()
                this.getProducts({ cardNumber: this.smart_card_number, type: this.data.tv_category })
            }
        },
    },

    methods: {
        selectCable(val) {
            this.data.tv_category = val.toLowerCase()
        },

        ...mapActions('Bill', {
            getCables: 'FETCH_CABLE_CATEGORIES',
            getProducts: 'FETCH_CABLE_PRODUCTS',
        }),

        verifyUserData() {
            this.loadCableUser = true
            this.cableUserSuccess = false
            verifyCableUser(this.smart_card_number, this.data.tv_category)
                .then((data) => {
                    this.loadCableUser = false
                    this.cableUserSuccess = true
                    const responseData = data.data.data.data
                    this.data.account_number = responseData.accountNumber
                    this.data.account_name = responseData.name
                })
                .catch((error) => {
                    console.dir(error)
                    this.loadCableUser = false
                    this.cableUserSuccess = false
                    this.setType(false)
                    this.createMessage(
                        error.response ? error.response.data.message : 'An error occured, Please try again later'
                    )
                })
        },

        checkTv() {
            if (!this.data.tv_category) {
                this.messageType('warning')
                this.createMessage('Please select a Provider')
            }
        },

        checkUser() {
            if (!this.data.account_number) {
                this.messageType('warning')
                this.createMessage('Please fill the blank spaces above')
            }
        },

        selectPlan(val) {
            this.data.bundle = val.bundleCode
            this.data.amount = val.amount
            this.option = val.name
        },

        ...mapActions('Message', {
            setType: 'SET_MESSAGE_TYPE',
            createMessage: 'SET_MESSAGE',
            messageType: 'SET_WARNING',
        }),

        proceed(val) {
            const fullData = Object.assign(this.data, val)
            this.$emit('proceed', fullData)
        },
    },

    mounted() {
        this.getCables()
    },
}
</script>

<style scoped>
.skeleton {
    width: 50px;
    height: 15px;
    border-radius: 10px;
    animation: pulse-bg 1s ease-in-out infinite normal both;
}
</style>
